import {mock} from './index';

export default {
  getStructureList: () => ('/admin/structure/root/list'),
  deleteStructure: () => '/admin/structure/delete',
  createStructure: () => mock('/admin/structure/create'),
  structureDetail: () => mock('/admin/structure/get'),
  setStructureStatus: () => '/admin/structure/autoDispatch/set',
  getStructureChildren: () => '/admin/structure/getChildren',
  modifyStructureName: () => mock('/admin/structure/modify'),
  getStructureAssetList: () => '/admin/structure/asset/list',
  assignAssetForStructure: () => '/admin/structure/asset/assign',
  getStructureUserAssignedList: () => '/admin/structure/user/assignedList',
  getCompleteStructureList: () => '/admin/structure/getCompleteStructure',
  syncAssets: () => '/admin/asset/sync',
  createTag: () => mock('/admin/structure/tag/create'),
  modifyTag: () => mock('/admin/structure/tag/modify'),
  getStructureTagList: () => mock('/admin/structure/tag/list'),
  deleteStructureTag: () => mock('/admin/structure/tag/delete'),
  checkTagKeyExist: () => mock('/admin/tag/validator'),
  getCompleteStructureOrdered: () => mock('/admin/structure/getCompleteStructureOrdered'),
  modifyStructureOrder: () => mock('/admin/structure/order/modify'),
  modifyAssetOrder: () => mock('/admin/structure/asset/order'),
  checkIsRelated: () => mock('/admin/structure/role/isRelated')
};
